import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "store";
import { fetchUserInfo } from "store/slices/userSlice";
import { Spinner } from "components/atoms";
import { COLOR_SYSTEM } from "components/design/design-system";

/**
 * 애플리케이션이 시작될 때 자동으로 사용자 인증 상태를 확인하는 컴포넌트
 * App 컴포넌트를 감싸서 사용합니다.
 */
const AuthInitializer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading } = useSelector((state: RootState) => state.user);
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    // 앱 시작 시 사용자 정보를 가져옵니다.
    // 쿠키에 토큰이 있으면 사용자 정보를 가져오고, 없으면 401 에러가 발생합니다.
    dispatch(fetchUserInfo()).finally(() => {
      setIsInitialized(true);
    });
  }, [dispatch]);

  // 초기 로딩이 완료될 때까지 대기
  if (!isInitialized || isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100vw',
          height: '100vh',
          backgroundColor: COLOR_SYSTEM.get("Gray")?.[50] || '#e4ebed',
        }}
      >
        <Spinner size="Large" />
        <p
          style={{
            marginTop: '20px',
            fontSize: '16px',
            color: COLOR_SYSTEM.get("Gray")?.[600] || '#4b5b69',
          }}
        >
          로딩 중...
        </p>
      </div>
    );
  }

  return <>{children}</>;
};

export default AuthInitializer;
